import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW4402Model } from '../../kymw4402/kymw4402.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 生協間ページ情報コピーサービス
 * @export CopyPageInfoToCoopsService
 * @class CopyPageInfoToCoopsService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class CopyPageInfoToCoopsService extends PlessJsonResponderSub<null> {
  model: KYMW4402Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof CopyPageInfoToCoopsService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.model.orderCode,
        MediumType: this.model.mediumType,
        CoopCode: this.model.coopCode,
        CopyCoopCodes: this.model.checkedCoopCodes,
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof CopyPageInfoToCoopsService
   */
  execute(model: KYMW4402Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('copyPageInfoToCoops', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @memberof CopyPageInfoToCoopsService
   */
  success() {
    if (this.calbak) this.calbak();
  }
}
